module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/top/es-MX/btn_result-text.png";